<template>
  <div>
    <h2>Select an API</h2>
    <MessageList />
    <ConductorApiList :conductorApis="conductorApis" />
    <hr />
    <h2>Update APIs</h2>
    <JsonEditor :value="conductorApis" @input="setConductorApis" />
    <button @click="saveConductorApis">Save into LocalStorage</button>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import ConductorApiList from '@/components/ConductorApiList.vue'
import JsonEditor from '@/components/JsonEditor.vue'
import MessageList from '@/components/MessageList.vue'

export default {
  name: 'ConductorApiEdit',
  computed: mapState(['conductorApis']),
  methods: mapMutations(['saveConductorApis', 'setConductorApis']),
  components: {
    MessageList,
    ConductorApiList,
    JsonEditor
  }
}
</script>
